import { useState } from "react";
import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`;

const Resumo = styled.div`
    margin: 15px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;

    p {
        margin: 0;
    }

    b {
        color: #242d34;
    }
`;

const ErrorMsg = styled.p`
    margin: 15px 0 0 0;
    font-size: 13px;
    color: #b91c1c;
    text-align: center;
`;

const BotoesWrapper = styled.div`
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#e11d48")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s all ease;

    &:disabled {
        background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#fda4af")};
        cursor: auto;
    }

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#be123c")};
    }
`;

const ModalConfirmRemoverResponsavel = ({
    conta,
    item,
    userIdsAtuais = [],
    fecharModal,
    onRemoved,
}) => {
    const api = useApi();
    const [removendo, setRemovendo] = useState(false);
    const [erro, setErro] = useState(null);

    const handleDelete = async () => {
        if (!item?.user_id || !conta) return;

        setRemovendo(true);
        setErro(null);

        const userIds = userIdsAtuais.filter((id) => id !== item.user_id);

        try {
            const { data } = await api.post(
                "/Painel/API/Contabilidade/Responsaveis/Save/index.php",
                { conta, user_ids: userIds }
            );

            if (data?.success) {
                await onRemoved?.();
                fecharModal();
                return;
            }

            setErro(data?.message || "Não foi possível remover o responsável.");
        } catch (error) {
            console.error("Erro ao remover responsável:", error);
            setErro(error?.response?.data?.message || "Erro ao remover responsável.");
        } finally {
            setRemovendo(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm">
                <Titulo>Confirmar remoção</Titulo>
                <Subtitulo>Tem certeza que deseja remover este responsável da conta?</Subtitulo>
                {item && (
                    <Resumo>
                        <p>
                            <b>USUÁRIO:</b> {item.usuario}
                        </p>
                        {item.email && (
                            <p>
                                <b>E-MAIL:</b> {item.email}
                            </p>
                        )}
                        <p>
                            <b>CONTA:</b> {conta}
                        </p>
                    </Resumo>
                )}
                {erro && <ErrorMsg>{erro}</ErrorMsg>}
                <BotoesWrapper>
                    <Botao $cancel type="button" onClick={fecharModal} disabled={removendo}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleDelete} disabled={removendo}>
                        {removendo ? "REMOVENDO..." : "REMOVER"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalConfirmRemoverResponsavel;
